import { Query } from '@varo/graphql-schema-types';
import GetCashbackTransactionDetails from 'services/graphql/queries/GetCashbackTransactionDetails';
import { useQuery } from 'urql';

const useCashbackTransactionDetails = (transactionId: string) => {
  const [
    { data: cashbackTransactionDetails, fetching: loading, error, stale },
  ] = useQuery<Query>({
    query: GetCashbackTransactionDetails,
    variables: { id: transactionId },
    requestPolicy: 'cache-and-network',
  });

  return {
    cashbackTransactionDetails:
      cashbackTransactionDetails?.myPartnerOffers?.cashback?.transaction,
    loading,
    error,
    stale,
  };
};

export default useCashbackTransactionDetails;
